import { Controller } from "stimulus"

// Bugfix 32 (#1566): een lijst filteren terwijl je typt (oefening vervangen in
// de sportersomgeving). Elk item heeft data-zoek met de doorzoekbare tekst.
export default class extends Controller {
  static targets = ["veld", "item"]

  filter() {
    const zoek = this.veldTarget.value.trim().toLowerCase()
    this.itemTargets.forEach((item) => {
      item.hidden = zoek !== "" && !(item.dataset.zoek || "").includes(zoek)
    })
  }
}
